import { locale } from '@tcc/i18n';
import { requestGet } from './request';
import { getRootUrl } from './url';

const SCRIPT_TAG_ID = 'glance-cobrowse';
const GLANCE_GROUP_ID = '20425';
const GLANCE_ENABLED_USER_CONFIG_FF = 'cfvweb.all.glance';
const SERVICE_ENDPOINT = '/api/user-config/v1/external/configs/values-with-reason/config-key/';

export async function getIsGlanceFeatureFlagEnable(userId) {
  try {
    const url = `${getRootUrl()}${SERVICE_ENDPOINT}feature-flag.${GLANCE_ENABLED_USER_CONFIG_FF}`;

    const response = await requestGet(url, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'x-user-id': userId
      }
    });

    const { value } = await response.json();

    return !['false', 'undefined', 'null', 'off', null, undefined, false].includes(value);
  } catch {
    return false;
  }
}

/**
 * Inject glance script tag
 * @param {number} userId
 * @returns {void}
 */
export const initializeGlance = async (userId) => {
  const existingTag = document.getElementById(SCRIPT_TAG_ID);
  if(existingTag) return;

  const head = document.getElementsByTagName('head')[0];
  const siteEnv = 'production';
  const glanceScript = document.createElement('script');
  glanceScript.async = true;
  glanceScript.id = SCRIPT_TAG_ID;
  glanceScript.charset = 'UTF-8';
  glanceScript.src =
    `https://www.glancecdn.net/cobrowse/CobrowseJS.ashx?group=${GLANCE_GROUP_ID}&site=${siteEnv}`;
  glanceScript.setAttribute('data-groupid', GLANCE_GROUP_ID);
  glanceScript.setAttribute('data-site', siteEnv);
  glanceScript.setAttribute('data-test-id', 'glance-cobrowse-script');
  glanceScript.setAttribute('glance_masked', 'true');
  glanceScript.setAttribute('data-visitorid', userId);
  glanceScript.setAttribute('data-presence', 'on');


  head.appendChild(glanceScript);

  const htmlElement = document.querySelector('html');
  if (htmlElement) {
    htmlElement.setAttribute('lang', locale);
  }

  // @ts-expect-error this is added in runtime
  window.GLANCE_COBROWSE = {disableLogging: true};
};